import { Spinner } from '@heroui/react'
import config from 'config'
import { useAuth } from 'hooks/useAuth'
import { useCallLogsPagination } from 'hooks/useCallsPagination'
import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { prefetchCallLogs } from 'utils/funcs/call-logs/callLogsQueries'
import BottomBar from '../components/Layout/BottomBar'
import { BottomBarProvider, useBottomBar } from '../components/Layout/BottomBarProvider'
import PageWrapper from '../components/Layout/PageWrapper'
import TopBar from '../components/Layout/TopBar'
import { TopBarProvider, useTopBar } from '../components/Layout/TopBarProvider'
import SideMenu from '../components/Navigation/SideMenu'

export default function Dashboard() {
  const { loading, user } = useAuth()
  const location = useLocation()
  const { take } = useCallLogsPagination()

  useEffect(() => {
    if (config.ENV !== 'development' && user && !location.pathname.includes('/dashboard/call-logs')) {
      prefetchCallLogs({ take, pages: 1 })
    }
  }, [user])

  if (loading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Spinner variant="spinner" />
      </div>
    )
  }

  const embedPathway = location.pathname.startsWith('/embed-pathway')

  if (!user && !embedPathway) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return (
    <TopBarProvider>
      <BottomBarProvider>
        <DashboardContent />
      </BottomBarProvider>
    </TopBarProvider>
  )
}

function DashboardContent() {
  const { topBarElements } = useTopBar()
  const { bottomBarElements } = useBottomBar()

  const hasBottomBarContent = Object.keys(bottomBarElements).length > 0

  return (
    <div className={`
      bg-light-secondary relative flex h-screen w-screen overflow-hidden pr-5
    `}
    >
      <SideMenu />
      <div className="flex h-full max-h-full w-full flex-col overflow-hidden">
        <TopBar>
          {topBarElements.content}
        </TopBar>
        <PageWrapper hasBottomBar={hasBottomBarContent}>
          <Outlet />
        </PageWrapper>
        {hasBottomBarContent && (
          <BottomBar>
            {bottomBarElements.content}
            {bottomBarElements.section}
            {bottomBarElements.actions}
          </BottomBar>
        )}
      </div>
    </div>
  )
}
